<template>
  <div class="orders">
    <div class="row">
      <div class="col-sm-12">
        <b-card bg-variant="white">
          <LoadingSpinner v-if="isLoading" />
          <Alerts />

            {{ /* table controllerscontrollers */ }}
            <div>
              <div class="form-group form-inline pull-left mb-2">
                <b-button
                  size="sm"
                  class="vgt-left-btn"
                  href="/guides/Address_Book_Reference_Guide.zip"
                >
                  <span class="glyphicon glyphicon-download-alt"></span>
                  Reference Guide
                </b-button>
                &nbsp;
                <import-addresses-button
                  @imported="imported"
                ></import-addresses-button>
                &nbsp;
                <b-button
                  class="vgt-left-btn"
                  size="sm"
                  @click="showAddContactModal"
                >New Contact</b-button>
                &nbsp;
                <!-- <b-button
                  href
                  @click="deleteUsers"
                  class="vgt-left-btn vgt-red"
                  size="sm"
                >Delete</b-button>&nbsp; -->
                <b-dropdown text="Delete" class="vgt-delete" variant="secondary" size="sm">
                  <b-dropdown-item @click="deleteUsers(false)" :disabled="serverParams.ids.length < 1">Delete Selected</b-dropdown-item>
                  <b-dropdown-item @click="deleteUsers(true)">Delete All</b-dropdown-item>
                </b-dropdown>&nbsp;
              </div>

              <div class="form-group form-inline pull-right mb-2">
                <b-input-group>
                  <b-input class="table-search border-right-0 border" v-model="searchkw" size="sm" placeholder="Search" @keypress.enter="onTableSearch"/>
                  <b-input-group-append>
                    <b-button
                      variant="outline-error"
                      class="border-left-0 border"
                      @click="onVGTClearSearch"
                    >
                      <i :class="['fa', 'fa-times', {'opacity-0': !searchkw}]"></i>
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-btn variant="success" @click="onTableSearch">
                      <i class="fa fa-search"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
                &nbsp;
                <b-dropdown id="dropdown-1" size="sm" text="Edit Columns" class="vgt-btn-right">
                  <b-dropdown-form style="padding-left: 0.5rem">
                    <b-form-checkbox-group v-model="selectedColumns">
                      <b-form-checkbox v-for="col in columnSelection" :key="col.field" :value="col.field">
                        {{ col.label }}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                    <b-dropdown-item-button @click="onVGTColumnSelect">
                      <b-button size="sm" class="vgt-btn-right" block>Apply</b-button>
                    </b-dropdown-item-button>
                  </b-dropdown-form>
                </b-dropdown>
                &nbsp;
                <b-button size="sm" @click="exportAddresses()">
                  Export Data
                  <span class="glyphicon glyphicon-download-alt"></span>
                </b-button>
              </div>
            </div>
            {{ /* table controllerscontrollers */ }}

            <div class="clearfix"></div>

            <b-row class="justify-content-end">
              <b-col sm="auto" style="z-index: 999;">
                <b-input-group class="mb-2">
                  <div class="db-help import">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" dropup no-caret>
                      <template slot="button-content">
                        <b-img src="/images/icons/information.png" />
                      </template>
                      <b-dropdown-text class="mb-0 py-1 px-2" style="width: 304px">
                        <ul>
                          <li>Maximum selected records is {{ serverParams.perPage }}</li>
                          <li>Records selected has to be within the current table</li>
                        </ul>
                      </b-dropdown-text>
                    </b-dropdown>
                  </div>
                  <b-form-input
                    class="table-search border-right-0 border"
                    size="sm"
                    v-model="customRange"
                    placeholder="Custom Range (e.g. 1-5, 10)"
                    style="width: 200px;"
                    @keyup.enter="customSelectedRows"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="outline-error"
                      class="border-left-0 border"
                      @click="(e) => {
                        if(customRange) {
                          customRange = '';
                        }
                      }"
                    >
                      <i :class="['fa', 'fa-times', {'opacity-0': !customRange}]"></i>
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-btn variant="success" @click="customSelectedRows">Go</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>

            {{ /* VGT */ }}
            <vue-good-table
              ref="vgt"
              mode="remote"
              :columns="columns"
              :rows="rows"
              styleClass="vgt-table striped bordered condensed"
              max-height="70vh"
              :select-options="{ enabled: true, selectOnCheckboxOnly: true, selectionText: selected_text, clearSelectionText: 'Unselect All', selectionInfoClass: selection_class }"
              :search-options="{ enabled: true, externalQuery: searchTerm }"
              :pagination-options="{ enabled: true, mode: 'records', rowsPerPageLabel: 'Records per page', perPageDropdown: [25, 50, 100, 200], dropdownAllowAll: false }"
              :totalRows="totalRecords"
              :line-numbers="true"
              @on-search="onVGTSearch"
              @on-selected-rows-change="onVGTSelected"
              @on-page-change="onVGTPageChange"
              @on-sort-change="onVGTSortChange"
              @on-per-page-change="onVGTPerPageChange"
            >
              <div slot="emptystate"> N/A </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'id'" class="d-flex justify-content-center">
                  <b-button
                    variant="primary"
                    class="btn-xs mr-1"
                    :href="`#/orders/new-shipment?addr=${props.row.id}`"
                  >Ship</b-button>
                  <b-button
                    class="view btn-xs"
                    variant="primary"
                    @click="editUser(props.row.id)"
                  >Edit</b-button>
                </span>
                <span v-else-if="props.column.field === 'address'">
                  {{props.row.address}}
                  <span v-if="props.row.address2">
                    <br />
                    {{props.row.address2}}
                  </span>
                </span>
                <span v-else-if="props.column.field === 'name'">
                  {{props.row.first_name}} {{props.row.last_name}}
                </span>

                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>

            </vue-good-table>
            {{ /* VGT */ }}

        </b-card>
      </div>
    </div>

    <div>
      <!-- ADD Customer Modal -->
    <b-modal
      ref="customsModal"
      size="lg"
      centered
      laze
      no-close-on-esc
      hide-header-close
      no-close-on-backdrop
      :visible="showAddModal"
      no-fade
    >
        <LoadingSpinner v-if="isNewContactLoading" />
        <template slot="modal-header">
          <div class="modal-title">
            Enter New Contact
          </div>
          <button @click="hideAddContactModal" type="button" aria-label="Close" class="close">×</button>
        </template>
        <template slot="modal-footer">
            <!--<b-button variant="primary" @click="suggestAddresses('addAddress')">Suggest Address</b-button>-->
            <b-btn
              size="sm"
              class="btn-light-blue-outline mr-2"
              @click="verifyAddress('addAddress')"
            >
              <img  class="verifyImg" src="/images/icons/verify-address-blue.png">
              Verify Address
            </b-btn>
            <b-btn class="btn-blue" @click="newContact">Save and Close</b-btn>
            <!-- <button type="button"
            class="btn btn-secondary btn-sm"
            data-dismiss="modal"
            style="background-color: #858888; border: 1px solid #858888;"
            @click="hideAddContactModal"
            >Close</button> -->
        </template>
        <Alerts ref="addAddress"/>

        <b-form-row v-if="!showLongAdress">
          <b-col sm="12" class="ml-1 mb-2">
            <a style="font-size: 0.875rem;" href="javascript:void(0)" @click="onShowLongAddress">
              <img width="23" src="/images/icons/paste-button.png" style="margin-top: -3px;">
              Click here to paste address
            </a>
          </b-col>
        </b-form-row>
        <b-form-row v-if="showLongAdress">
          <b-col>
            <b-form-group>
              <b-form-textarea
                v-model="long_address"
                placeholder="Name
Company (Optional)
Address Line 1
Address Line 2 (Optional)
City State Postal Code"
                rows="5"
                @change="onLongAddressChange"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="n-acct_id"
                placeholder="Account ID"
                v-model="user.acct_id"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="n-first_name"
                placeholder="First Name"
                v-model="user.first_name"
              >
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="n-last_name"
                placeholder="Last Name"
                v-model="user.last_name"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="n-company"
                placeholder="Company"
                v-model="user.company"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <GoogleAutoComplete
                :g-class="['form-control', 'form-control-sm']"
                v-model="user.address"
                :country="user.country"
                @change="onGoogleAddressChange"
              ></GoogleAutoComplete>
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="n-address2"
                placeholder="Address 2"
                v-model="user.address2"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <zip-code-input
                class="form-control form-control-sm"
                id="n-postal"
                placeholder="Postal Code"
                v-model="user.postal_code"
                :formatZip="user.country === 'US'"
                @change="getCityState"
              />
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="n-city"
                :disabled="isLoading"
                placeholder="City"
                v-model="user.city"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="n-state"
                :disabled="isLoading"
                placeholder="State/Province"
                v-model="user.province"
              >
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <b-form-select
                v-model="user.country"
                :options="countrySelectOptions"
                size="sm"
                :disabled="isLoading"
                placeholder="Enter country"
              />
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="email"
                class="form-control form-control-sm"
                id="n-email"
                placeholder="Email"
                v-model="user.email"
              >
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <input
                type="tel"
                class="form-control form-control-sm"
                id="n-phone"
                placeholder="Phone"
                v-model="user.phone"
                maxlength="25"
              >
            </div>
          </b-col>
        </b-form-row>
      </b-modal>
      <!-- end of add modal -->
      <!-- Edit Customer Modal -->
      <b-modal
        ref="customsModal"
        size="lg"
        centered
        laze
        no-close-on-esc
        hide-header-close
        no-close-on-backdrop
        :visible="showEditModal"
        no-fade
      >
        <template slot="modal-header">
          <div class="modal-title">
            Edit Contact
          </div>
          <button @click="hideEditContactModal" type="button" aria-label="Close" class="close">×</button>
        </template>
        <template slot="modal-footer">
          <b-btn
            class="btn-light-blue-outline mr-2"
            size="sm"
            @click="verifyAddress('editAddress')"
          >
            <img class="verifyImg" src="/images/icons/verify-address-blue.png">
            Verify Address
          </b-btn>
          <b-btn class="btn-blue" @click="updateContact">Save and Close</b-btn>
          <!-- <b-button variant="danger" @click="deleteUser(user.id)">Delete</b-button> -->
          <!-- <button type="button"
          class="btn btn-secondary btn-sm"
          style="background-color: #858888; border: 1px solid #858888;"
          @click="hideEditContactModal"
          >Close
          </button> -->
        </template>
        <Alerts ref="editAddress"/>

        <b-form-row v-if="!showLongAdress">
          <b-col sm="12" class="ml-1 mb-2">
            <a style="font-size: 0.875rem;" href="javascript:void(0)" @click="onShowLongAddress">
              <img width="23" src="/images/icons/paste-button.png" style="margin-top: -3px;">
              Click here to paste address
            </a>
          </b-col>
        </b-form-row>
        <b-form-row v-if="showLongAdress">
          <b-col>
            <b-form-group>
              <b-form-textarea
                v-model="long_address"
                placeholder="Name
Company (Optional)
Address Line 1
Address Line 2 (Optional)
City State Postal Code"
                rows="5"
                @change="onLongAddressChange"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="n-acct_id"
                placeholder="Account ID"
                v-model="user.acct_id"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="first_name"
                placeholder="First Name"
                v-model="user.first_name"
              >
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="last_name"
                placeholder="Last Name"
                v-model="user.last_name"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="company"
                placeholder="Company"
                v-model="user.company"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <GoogleAutoComplete
                :g-class="['form-control', 'form-control-sm']"
                v-model="user.address"
                :country="user.country"
                @change="onGoogleAddressChange"
              ></GoogleAutoComplete>
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="address2"
                placeholder="Address 2"
                v-model="user.address2"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <zip-code-input
                class="form-control form-control-sm"
                id="postal"
                placeholder="Postal Code"
                v-model="user.postal_code"
                :formatZip="user.country === 'US'"
                @change="getCityState"
              />
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="city"
                placeholder="City"
                :disabled="isLoading"
                v-model="user.city"
              >
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-sm"
                id="state"
                placeholder="State/Province"
                :disabled="isLoading"
                v-model="user.province"
              >
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <b-form-select
                v-model="user.country"
                size="sm"
                :options="countrySelectOptions"
                :disabled="isLoading"
                placeholder="Enter country"
              />
            </div>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <div class="form-group">
              <input
                type="email"
                class="form-control form-control-sm"
                id="email"
                placeholder="Email"
                v-model="user.email"
              >
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <input
                type="tel"
                class="form-control form-control-sm"
                id="phone"
                placeholder="Phone"
                v-model="user.phone"
                maxlength="25"
              >
            </div>
          </b-col>
        </b-form-row>
      </b-modal> <!-- edit modal -->
    </div>
  </div>
</template>
<style lang="scss">
.datepicker-button {
  &:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }

  & + .calendar-root {
    .input-date {
      display: none;
    }
    .calendar {
      left: 0px;
      top: 35px;
      height: auto;
      min-height: 300px;
    }
  }
}
.orders-table {
  tbody {
    td {
      text-align: center !important;
    }
  }
  tfoot {
    background-color: rgba(#1e88e5, 0.1);
  }
}
textarea {
  font-size: .875rem !important;
  resize: none !important;
}
</style>

<script>
import LoadingSpinner from "../../components/LoadingSpinner";
import Alerts from "../../components/Alerts";
import moment from "moment";
import Cookies from 'js-cookie';
import { VueGoodTable } from 'vue-good-table';
import { mapActions, mapGetters } from "vuex";
import formatters from "../../formatters";
import ImportAddressesButton from "../../components/ImportAddressesButton";
import countries from "../../data/countries.js";
import hash from 'object-hash';
import lStore from '../Orders/Mixins/lStore';
import GoogleAutoComplete from "../../components/GoogleAutoComplete";

import human from 'parse-full-name';
import parser from 'parse-address';

export default {
  components: {
    VueGoodTable,
    LoadingSpinner,
    Alerts,
    ImportAddressesButton,
    GoogleAutoComplete
  },
  // add props orderStatusId -> id & orderType -> name
  data(){
    return {
      customRange: '',
      selected_text: 'Records Selected',
      selection_class: 'vgtSelectInfo',
      showLongAdress: false,
      isLoading: false,
      isNewContactLoading: false,
      showAddModal: false,
      showEditModal: false,
      shipping_addresses: [],
      suggestedAddresses: [],
      user: {
        country: "US"
      },
      long_address: '',
      // value could be 3 for shipped,4 for voided,5 for returns
      orderType: {
        id: 3,
        name: 'shipped',
      },

      // for modal
      shown: null,
      shownObjs: {},

      selectedColumns: [
        "name", "company", "address", "city", "province",
        "postal_code", "country", "email", "phone",
      ],
      selected: [],
      searchkw: '',
      searchTerm: '',
      serverParams: {
        columns: null,
        searchTerm: '',
        ids: [],
        columnFilters: null,
        sort: null,
        page: null,
        perPage: null
      },
      totalRecords: 0,
      rows: [],
      columns: [
        {
          field: 'id', label: "Actions",
          thClass:"vgt-headers narrower",
          sortable: false,
        },
        {
          field: 'acct_id', label: "Account ID",
          thClass:"vgt-headers", hidden: true,
        },
        {
          field: 'name', label: "Recipient",
          thClass:"vgt-headers",
        },
        {
          field: 'company', label: "Company",
          thClass:"vgt-headers",
        },
        {
          field: 'address', label: "Address",
          thClass:"vgt-headers",
        },
        {
          field: 'city', label: "City",
          thClass:"vgt-headers narrower",
        },
        {
          field: 'province', label: "State/Province",
          thClass:"vgt-headers narrower",
        },
        {
          field: 'postal_code', label: "Postal Code",
          thClass:"vgt-headers narrower",
        },
        {
          field: 'country', label: "Country",
          thClass:"vgt-headers narrower",
        },
        {
          field: 'email', label: "Email",
          thClass:"vgt-headers",
        },
        {
          field: 'phone', label: "Phone",
          thClass:"vgt-headers",
        }
      ],
    }
  }, // end of data
  watch: {
    searchkw: function(newVal,oldVal){
      if(!newVal || !newVal.length) {
        this.onVGTClearSearch()
      }
    }
  },
  computed: {
    ...mapGetters(["recipients"]),
    columnSelection(){
      return this.columns.map(v => {
        const {field, label} = v;
        if(v.field !== 'id') return { field, label};
      }).filter(v => !!v);
    },
    countrySelectOptions() {
      return countries.getSelectOptions();
    },
    suggestedAddressesOptions() {
      return this.suggestedAddresses.map(address => {
        return {
          text: formatters.address.oneLine(address),
          value: address
        };
      });
    },
    shippingAddresses() {
      return this.recipients;
    }
  },
  async mounted() {
    const perPage = lStore.get('addressBookPerPage');
    if(perPage){
      this.serverParams.perPage = perPage;
    }
    const cols = lStore.get('addressBookCols');
    if(cols){
      const { columns, selectedColumns } = cols;
      this.columns = columns;
      this.selectedColumns = selectedColumns;
    }
    this.fetchAddresses();
  },
  methods: {
    ...mapActions(["refreshRecipients"]),
    // VGT EVENTS
    updateVGTParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onVGTSelected(params) {
      console.log('on select', params);
      if(params.selectedRows.length > 0){
        const ids = params.selectedRows.map( v => v.id);
        this.updateVGTParams({ids});
      }else {
        this.updateVGTParams({ids: []});
      }
    },
    onVGTSearch(params) {
      console.log('on search', params);
      this.updateVGTParams({searchTerm: params.searchTerm});
      this.fetchAddresses();
    },
    onVGTClearSearch(){
      this.searchkw = '';
      this.searchTerm = '';
    },
    async onTableSearch(){
      this.searchTerm = this.searchkw
    },
    onVGTPageChange(params) {
      console.log('on pagination', params);
      this.updateVGTParams({page: params.currentPage});
      this.fetchAddresses();
    },
    onVGTPerPageChange(params) {
      console.log('on per page change', params);
      this.updateVGTParams({perPage: params.currentPerPage});
      lStore.set('addressBookPerPage', params.currentPerPage);
      // needs to clear everything since since the number of pages is already invalid
      this.fetchAddresses();
    },
    onVGTSortChange(params) {
      console.log('on sort change', params);
      if(!params.length) return
      const {field, type} = params[0];
      this.updateVGTParams({ sort: [field, type] });
      this.fetchAddresses();
    },
    onVGTColumnSelect(){
      console.log('on selectColumns',  this.selectedColumns);
      this.columns = this.columns.map(column => {
        if(column.field !== 'id'){
          column.hidden = this.selectedColumns.includes(column.field) ? false : true;
        }
        return column;
      });
      lStore.set('addressBookCols', Object.assign({}, {columns: this.columns, selectedColumns: this.selectedColumns}));
      this.updateVGTParams({columns: this.selectedColumns});
    }, // VGT EVENTS

    async imported(){
      await Promise.all([
        this.fetchAddresses(),
        this.refreshRecipients(),
      ]);
    },
    async fetchAddresses(page_url = "/addresses?ajax=true") {
      this.isLoading = true;
      try{
      const response = await axios.get(page_url, {
          params: Object.assign({}, this.serverParams)
      });
      const {data: {data, total}} = response;
      console.log('data, total', data, total);
      this.totalRecords = total;
      this.rows = data;
      console.log('rows', this.rows);
      }catch(e){
        console.error(e);
      }finally{
        this.isLoading = false;
      }
    },
    newContact: function() {
      const {company, first_name, last_name, address, postal_code} = this.user;
      if(!(address || postal_code)){
        this.$emit('alert', {
          message: 'Address and Postal are required',
          type: 'danger'
        });
      }else if(!(company || first_name || last_name)){
        this.$emit('alert', {
          message: 'Please provide at least one of the following: Compnay, First Name, or Last Name.',
          type: 'danger'
        });
      }else{
        this.isLoading = true;
        axios
          .post("/addresses", this.user)
          .then(response => {
            this.fetchAddresses();
            this.user = { country: "US" };
            this.showAddModal = false;
            this.showLongAdress = false;
          })
          .catch(error => {
            console.log(error.response.data.message);
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshRecipients();
          });
      }
    },
    editUser(id) {
      this.isLoading = true;
      axios
        .get("/addresses/" + id + "/edit")
        .then(response => {
          this.user = response.data;
          this.showEditModal = true;
        })
        .catch(error => {
          console.log(error.response.data.message);
        })
        .finally(() => {
          this.isLoading = false;
          this.refreshRecipients();
        });
    },
    async deleteUsers(all=false) {
      let dialog = null;

      let ids = []
      let msg= ""
      let data = {}
      let title = 'Delete Records'
      let proceed = 'Delete'
      if (all) {
        title = 'Delete All'
        proceed = 'Delete All'
        data = { all: true };
        msg = `You are attempting to delete ${ this.totalRecords } records.&nbsp;&nbsp;This action is irreversible.`;
      } else {
        ids = this.serverParams.ids;
        data = { ids };
        msg = `You are attempting to delete ${ ids.length } records.&nbsp;&nbsp;This action is irreversible.`;
      }

      try{
        dialog = await this.$dialog.confirm({ title: title, body: msg }, {
          view: 'warning',
          customClass: 'warning-dialog',
          proceed: proceed,
        });
        this.isLoading = true;
        const deleteResponse = await axios.post("/addresses/delete", data);
        console.log(deleteResponse);
      }catch(e){
        console.error('error deleting data', e.message);
      }finally{
        this.updateVGTParams({ids: []});
        this.isLoading = false;
        this.fetchAddresses();
        if(dialog) dialog.close();
      }
    },
    updateContact() {
      const {company, first_name, last_name, address, postal_code} = this.user;
      if(!(address || postal_code)){
        this.$emit('alert', {
          message: 'Address and Postal are required',
          type: 'danger'
        });
      }else if(!(company || first_name || last_name)){
        this.$emit('alert', {
          message: 'Please provide at least one of the following: Compnay, First Name, or Last Name.',
          type: 'danger'
        });
      }else{
        this.isLoading = true;
        axios
          .patch("/addresses/" + this.user.id, { user: this.user })
          .then(response => {
            // this.isLoading = false;
            $("#editCustomer").modal("hide");
            this.fetchAddresses();
            this.user = { country: "US" };
            this.showEditModal = false;
            this.$emit("alert", {
              message: "Address saved!",
              type: "success"
            });
          })
          .catch(error => {
            console.log(error.response.data.message);
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshRecipients();
          });
      }
    },
    // suggestAddresses(form) {
    //   let address = formatters.address.toPb(this.user);
    //   this.isLoading = true;
    //   this.suggestedAddresses = [];
    //   axios
    //     .post("/addresses/suggest", { address: address })
    //     .then(response => {
    //       this.isLoading = false;

    //       let address = response.data.address;

    //       if (
    //         address &&
    //         (address.status === "VALIDATED_CHANGED" ||
    //           address.status === "VALIDATED_AND_NOT_CHANGED")
    //       ) {
    //         this.user = formatters.address.fromPb(address);
    //       }

    //       if (
    //         response.data.suggestions &&
    //         response.data.suggestions.address &&
    //         response.data.suggestions.address.length
    //       ) {
    //         this.suggestedAddresses = response.data.suggestions.address;
    //       }
    //     })
    //     .catch(error => {
    //       this.isLoading = false;
    //       this.$emit("alert", {
    //         message:
    //           address.countryCode === "US"
    //             ? "Address is invalid!"
    //             : "Sorry, address verification is only for U.S. addresses",
    //         type: "danger"
    //       });
    //       window.scrollTo(0, 0);
    //     });
    // },
    onChangeSuggestedAddress(value) {
      this.user = formatters.address.fromPb(value);
    },
    verifyAddress(form) {
      let address = formatters.address.toPb(this.user);
      this.isLoading = true;
      this.suggestedAddresses = [];
      axios
        .post("/verify", { address: address })
        .then(response => {
          this.isLoading = false;

          this.$refs[form].setValue({
            message: this.$t("alerts.address.valid"),
            type: "success"
          });

          let address = response.data;

          if (
            address &&
            (address.status === "VALIDATED_CHANGED" ||
              address.status === "VALIDATED_AND_NOT_CHANGED")
          ) {
            // Mass-assign to not delete name
            address = formatters.address.fromPb(address);
            this.user = Object.assign({}, this.user, address);
          }

          /*

          if (
            response.data.suggestions &&
            response.data.suggestions.address &&
            response.data.suggestions.address.length
          ) {
            this.suggestedAddresses = response.data.suggestions.address;
            this.$refs[form].setValue({
              message: this.$t("alerts.address.suggestions_found"),
              type: "success"
            });
          } else if (address) {
            address.status === "VALIDATED_CHANGED"
              ? this.$refs[form].setValue({
                  message: this.$t("alerts.address.formatted_no_suggestions"),
                  type: "success"
                })
              : this.$refs[form].setValue({
                  message: this.$t("alerts.address.valid"),
                  type: "success"
                });
          }*/
        })
        .catch(error => {
          this.isLoading = false;
          this.$refs[form].setValue({
            message:
              address.countryCode === "US"
                ? "Address is invalid!"
                : "Sorry, address verification is only for U.S. addresses",
            type: "danger"
          });
          window.scrollTo(0, 0);
        });
    },
    async showAddContactModal(){
      this.user = {country: 'US'};
      this.showAddModal = true;
    },
    async hideAddContactModal(){
      this.long_address = '';
      this.user = {};
      this.showAddModal = false;
      this.showLongAdress = false
    },
    async showEditContactModal(){
      this.showEditModal = true;
    },
    async hideEditContactModal(){
      this.user = {};
      this.showEditModal = false;
    },
    // EXPORT
    async exportAddresses() {
      try{
        const msg = 'The active columns will be exported into a CSV file';
        if(!Cookies.get(hash(msg))){
          let dialog = await this.$dialog.confirm({ title: 'Export Data', body: msg }, {
            remember: true,
            view: 'print',
            customClass: 'print-dialog',
            proceed: 'Export'
          });
          dialog.close();
        }

        const url = `/addresses/export`;
        const headings = this.columns.map(column => {
          if(this.selectedColumns.includes(column.field) && column.field !== 'id'){
            return {[column.field]: column.label};
          }
        }).filter(v => !!v);
        const data = { headings, dateNow: moment().format('MMDDYYYY') }

        const response = await axios.post(url, data, {
          params: Object.assign({}, this.serverParams)
        });
        // console.log('export response', response);
        window.open(response.data.url);
      } catch(e) {
        console.log(e);
      }
    }, // EXPORT
    async getCityState() {
      if (this.user.country == 'US') {
        const zip = this.user.postal_code;
        console.log('on change', zip);
        if(zip){
          this.isLoading = true;
          const url = "https://zip.getziptastic.com/v2/US/" + zip;
          var axiosCrossDomain = axios;
          delete axiosCrossDomain.defaults.headers.common["X-CSRF-TOKEN"];
          delete axiosCrossDomain.defaults.headers.common["X-Requested-With"];
          try{
            const response = await axiosCrossDomain(url, { method: "GET" });
            this.user.city = response.data.city;
            this.user.province = response.data.state_short;
            // this.user.country = response.data.country;
            // console.log(this.user);
          }catch(error) {
            console.log('unable to locate postal code: ', error.message);
          }finally{
            this.isLoading = false;
          }
        }
      }
    },
    async onGoogleAddressChange(addr){
      console.log('Addr', addr);
      this.user = Object.assign({}, this.user, addr);
      console.log('toAddr', this.user);
    },
    onLongAddressChange(val) {
      if (val) {
        this.parseAddress(val);
      } else {
        this.onClearItems();
      }
    },
    onClearItems() {
      this.user = {
        company: '',
        first_name: '',
        last_name: '',
        state: '',
        province: '',
        city: '',
        address: '',
        address2: '',
        postal_code: '',
        country: 'US',
      }
      this.long_address = ''
    },
    async parseAddress(long_address) {
      let address = long_address.split(/\r?\n/).map(a => a.trim()).filter(a => a.length > 0);

      if (address.length === 1) {
        address = long_address.split(/,/).map(a => a.trim()).filter(a => a.length > 0);
        this.long_address = address.join('\r\n');
      }

      if (address.length > 2) {
        this.isNewContactLoading = true;
        // check if country is on the last element then remove
        if (['us', 'usa', 'america', 'united states', 'united states of america'].includes(address[address.length - 1].trim().toLowerCase())) {
          address.pop();
        }

        // parse name (Expecting that the first row is name)
        let first = address.shift();
        let parsedName = human.parseFullName(first);

        // if address doesn't have number, move it to company
        let second = address[0];
        let company = '';

        const re = /\d/;
        if (!re.test(second)) {
          company = second;
          address.shift();
        }

        // address parser
        const parsedAddress = parser.parseLocation(address.join(' '));
        const postal_code = parsedAddress.plus4 ? `${parsedAddress.zip}-${parsedAddress.plus4}` : parsedAddress.zip

        if (!postal_code) {
          this.isNewContactLoading = false;
          this.$emit('alert', {
            message: 'Postal code is required.',
            type: 'danger'
          });
        } else {
          // get city state from ziptastic api
          const city_state = await this.getCityState(postal_code);

          let data = {
            company: company,
            first_name: parsedName.first,
            last_name: parsedName.last,
            state: city_state.state,  // new shipment uses province
            province: city_state.province,
            city: city_state.city,
            address: address[0],
            address2: address.length > 2 ? address[1] : '',
            postal_code: postal_code,
            country: 'US',
          }

          this.user = Object.assign({}, this.user, data)
        }
      }
    },
    // async getCityState(zip) {
    //   if (this.user.country == 'US') {
    //     this.isNewContactLoading = true;

    //     let url = "https://zip.getziptastic.com/v2/US/" + zip;
    //     var axiosCrossDomain = axios;
    //     delete axiosCrossDomain.defaults.headers.common["X-CSRF-TOKEN"];
    //     delete axiosCrossDomain.defaults.headers.common["X-Requested-With"];

    //     try {
    //       const { data } = await axiosCrossDomain(url, { method: "GET" });
    //       const pattern = /^(APO|FPO|DPO)\s(AE|AA|AP)$/
    //       let {state_short, city, country} = data;

    //       if(pattern.test(city.toUpperCase())){
    //         const [c,s] = city.split(" ");
    //         state_short = s;
    //         city = c;
    //       }

    //       this.user.city = city;
    //       this.user.province = state_short;
    //       this.user.state = state_short;
    //       // this.user.country = country;

    //       return {
    //         city: city,
    //         province: state_short,
    //         state: state_short,
    //       }
    //     } catch(error) {
    //       console.log('City State Error: ', error);
    //     } finally {
    //       this.isNewContactLoading = false;
    //     }
    //   }
    // },
    onShowLongAddress() {
      this.showLongAdress = true;
    },
    customSelectedRows() {
      if (this.customRange) {
        for(let i = 0; i < this.rows.length; i++) {
          this.$set(this.rows[i], 'vgtSelected', false);
        }

        const subtractTo = (this.serverParams.page - 1) * this.serverParams.perPage;
        let parseRange = [], start, end;

        this.customRange.split(',').forEach(i => {
          if (i.indexOf('-') > 0) {
            [start, end] = i.split('-').map(Number)
            if (start <= this.totalRecords && start < end) {
              if (end > this.totalRecords) {
                end = (this.serverParams.page || 1) * this.serverParams.perPage
              }
              _.range(start, end + 1).forEach(i => {
                i = subtractTo > 0 ? i - subtractTo : i
                parseRange.push(i)
              });
            }
          } else {
            i = parseInt(i);
            if (i <= this.totalRecords) {
              i = subtractTo > 0 ? i - subtractTo : i
              parseRange.push(i)
            }
          }
        })

        _.uniq(parseRange).forEach(i => {
          if (this.rows[i - 1]) {
            this.$set(this.rows[i-1], 'vgtSelected', true);
          }
        })
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/AddressBook/Index.vue